import { CONFIG } from 'src/global-config';

/** Only Qualtrics-hosted surveys are embedded. Anything else counts as unconfigured. */
export function isAllowedSurveyUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' && parsed.hostname.endsWith('.qualtrics.com');
  } catch {
    return false;
  }
}

/** The usable survey URL for a milestone, or null when it is missing or not Qualtrics-hosted. */
export function findSurveyUrl(checkInNumber: number): string | null {
  const url = CONFIG.qualtricsCheckInUrls[String(checkInNumber)];
  return url && isAllowedSurveyUrl(url) ? url : null;
}
